import React, { useState, useRef } from "react";
import PlanList from "./PlanList";
import CreatePlanForm from "./CreatePlanForm";

const Plans = () => {
  const [activeTab, setActiveTab] = useState("list");
  // ✅ ADD THIS STATE
  const [showPHINotice, setShowPHINotice] = useState(() => {
    // Check if user has dismissed the notice in this session
    return sessionStorage.getItem("plansPhiNoticeDismissed") !== "true";
  });
  const planListRef = useRef();

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleCreated = () => {
    handleTabChange("list");

    // Give the tab switch time to render before refreshing
    setTimeout(() => {
      if (planListRef.current) {
        planListRef.current.refresh();
      }
    }, 100);
  };

  // ✅ ADD THIS FUNCTION
  const handleDismissPHINotice = () => {
    setShowPHINotice(false);
    sessionStorage.setItem("plansPhiNoticeDismissed", "true");
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">📁 Plans</h4>
        <span className="badge bg-info">
          <i className="bi bi-shield-lock-fill me-1"></i>
          PHI Protected Module
        </span>
      </div>

      {/* ✅ REPLACE THE ENTIRE PHI NOTICE SECTION WITH THIS */}
      {showPHINotice && (
        <div
          className="alert alert-info alert-dismissible fade show mb-3"
          role="alert"
        >
          <h6 className="alert-heading">
            <i className="bi bi-info-circle-fill me-2"></i>
            Protected Health Information Notice
          </h6>
          <small>
            This module contains Protected Health Information (PHI). All access
            and actions are monitored and logged for HIPAA compliance. Only
            authorized personnel should access consumer treatment plans.
          </small>
          <button
            type="button"
            className="btn-close"
            onClick={handleDismissPHINotice}
            aria-label="Close"
          ></button>
        </div>
      )}

      <ul className="nav nav-tabs">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "list" ? "active" : ""}`}
            onClick={() => setActiveTab("list")}
          >
            All Plans
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "create" ? "active" : ""}`}
            onClick={() => setActiveTab("create")}
          >
            Create Plan
          </button>
        </li>
      </ul>

      <div className="tab-content">
        {activeTab === "list" && <PlanList ref={planListRef} />}
        {activeTab === "create" && <CreatePlanForm onCreated={handleCreated} />}
      </div>
    </div>
  );
};

export default Plans;
